import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { GoogleFreeBookingLinksSettings } from "./query";

type Props = {
	hotelID: string;
};

export const useFetchGoogleFreeBookingLinksSettings = ({ hotelID }: Props) => {
	return useCustomSuspenseQuery(GoogleFreeBookingLinksSettings, {
		variables: {
			hotelID,
		},
	});
};
